import { render, staticRenderFns } from "./cart-item-order.vue?vue&type=template&id=6517bc90"
import script from "./cart-item-order.vue?vue&type=script&lang=js"
export * from "./cart-item-order.vue?vue&type=script&lang=js"
import style0 from "./cart-item-order.vue?vue&type=style&index=0&id=6517bc90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports